module.exports = __webpack_public_path__ + "img/ro_float_half.f6effe15.png";